import { LottieLoading } from "../../../components/Loading/LottieLoading";
import { ReactComponent as More } from "../../../assets/icons/more.svg";
import dayjs from "dayjs";
import { ActionView } from "./ActionView";
import UIPopover from "../../../components/UIPopover";
import { GroupTag } from "../sales-aid-modal/components/GroupTag";
import { useApp } from "../../../services/app-context";
import { api } from "../../../services/api";
import { ShowToast } from "../../../services/toast";
import { useState } from "react";

export function GroupTagList({ groups, groupOptions }: { groups: any[] | null | undefined; groupOptions: any[] }) {
    const safeGroups = groups ?? [];
    const selectedGroups = groupOptions.filter((group) => safeGroups.includes(group.key));
    return (
        <div className="flex items-center gap-2 flex-wrap">
            {selectedGroups.map(group => <GroupTag key={group.key} selectedGroup={group} />)}
            {selectedGroups.length === 0 && "-"}
        </div>
    )
}

export default function MaterialTable({ data, isLoading, error, onDelete, isAdmin, onEdit, onCohortAssignment, onPreview }: { data: any[], isLoading: boolean, error: any, onDelete: (file: any) => void, isAdmin: boolean, onEdit: (file: any) => void, onCohortAssignment: (file: any) => void, onPreview: (file: any) => void }) {
    const { tenantProfile } = useApp();
    const [downloadingFileId, setDownloadingFileId] = useState<string | null>(null);

    const handleDownload = async (file: any) => {
        const idKey = String(file.id);
        try {
            setDownloadingFileId(idKey);
            const response = await api.getSalesAidFileSignedURL(file.id);
            if (response.status !== 200 || !response.data?.signedUrl) {
                ShowToast({ message: "Failed to download file", type: "error" });
                return;
            }

            const signedUrl = response.data.signedUrl as string;
            const fileRes = await fetch(signedUrl);
            if (!fileRes.ok) throw new Error("Failed to fetch file");

            const blob = await fileRes.blob();
            const blobUrl = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = blobUrl;
            a.download = file.file_name || "download";
            a.rel = "noopener noreferrer";
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(blobUrl);
        } catch {
            ShowToast({ message: "Failed to download file", type: "error" });
        } finally {
            setDownloadingFileId((current) => (current === idKey ? null : current));
        }
    };

    return (
        <div className="max-h-[calc(100vh-340px)] overflow-y-auto w-full">
            <table className="w-full">
                <colgroup>
                    <col className="w-[35%]" />
                    <col className="w-[20%]" />
                    <col className="w-[25%]" />
                    <col className="w-[10%]" />
                    <col className="w-[5%]" />
                </colgroup>
                <thead className="sticky top-0 z-[1] !border-b-[0px]">
                    <tr className="[&>th]:text-xs [&>th]:bg-background2 [&>th]:text-left [&>th]:font-semibold  [&>th]:text-gray-701 [&>th]:!h-9">
                        <th className="flex items-center pl-4 gap-2 !rounded-tl-[9px]">
                            FILE NAME
                        </th>
                        <th>
                            <div className="flex items-center gap-2">
                                DOC CODE
                            </div>
                        </th>
                        <th>
                            COHORT
                            {/* {sortBy === 'cohort' && <ArrowDown className={`w-4 h-4 [&_path]:fill-black ${sortDirection === 'DESC' ? 'rotate-[270deg]' : 'rotate-90'}`} />} */}
                        </th>
                        <th>
                            <div className="flex items-center gap-2">
                                DATE UPLOADED
                            </div>
                        </th>
                        <th className="rounded-tr-[9px]"></th>
                    </tr>
                </thead>
                <tbody className="[&_td]:py-2">
                    {!isLoading && data.map((item, index) => (
                        <tr className="text-[17px]" key={index}>
                            <td className="pl-4 text-black-600 text-xs">{item.file_name}</td>
                            <td className="text-black-600 text-xs">{item.code || "-"}</td>
                            <td>
                                <div>
                                    <GroupTagList groups={item.groups} groupOptions={tenantProfile?.groups || []} />
                                </div>
                            </td>
                            <td className="text-gray-601 text-xs">{dayjs(item.created_at).format("MMM DD, YYYY")}</td>
                            <td>
                                <UIPopover
                                    trigger={
                                        <span className="block p-2">
                                            <More />
                                        </span>
                                    }
                                >
                                    {(close) => (
                                        <ActionView
                                            onDelete={() => {
                                                onDelete(item);
                                                close();
                                            }}
                                            onEdit={() => {
                                                onEdit(item);
                                                close();
                                            }}
                                            isAdmin={isAdmin}
                                            onCohortAssignment={() => {
                                                onCohortAssignment(item);
                                                close();
                                            }}
                                            onPreview={() => {
                                                onPreview(item);
                                                close();
                                            }}
                                            onDownload={() => {
                                                handleDownload(item);
                                            }}
                                            isDownloading={downloadingFileId === String(item.id)}
                                        />
                                    )}
                                </UIPopover>
                            </td>
                        </tr>
                    ))}


                    {isLoading && (
                        <tr>
                            <td colSpan={5} className="text-center">
                                <LottieLoading className="h-[calc(100vh-500px)]" />
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
            {!isLoading && data.length === 0 && (
                <div className="text-center w-full h-20 flex items-center justify-center">
                    No data found
                </div>
            )}
            {/* {
                !isLoading && data.length === 0 && (
                    <div className="text-center w-full h-[calc(100vh-500px)] flex items-center justify-center">No data found</div>
                )
            } */}
            {/* <Button variant="primary" onClick={onAddPracticeMaterials} className="mt-4">Add Practice Materials</Button> */}
        </div>
    )
}